import React, { useEffect, useState } from "react";
import { TwoRow } from "../../core/layouts";
import { Input, Text, Radio } from "react_reusable_components";
import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import variables from "../../themes/base/styles/variables";
import Style from "./AssignSubProductCategoryStyles.module.scss";

const style = {
  bottomSectionStyle: {
    height: "24rem",
    border: `1px solid ${variables.grey4}`,
    width: variables.fullWidth,
    overflow: "auto",
    borderTop: "none",
    display: variables.dFlex,
    flexDirection: "column",
  },
  optionItemStyle: {
    padding: `${variables.paddingSmaller} ${variables.paddingSmall}`,
    display: variables.dFlex,
    justifyContent: variables.spaceBetween,
  },
  optionNameStyle: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.fontSizeXxlarge,
    color: variables.textDefault,
    textTransform: "capitalize",
  },

  rightArrowIconStyle: {
    color: variables.textDefault,
    width: variables.smallIconWidth,
    height: variables.smallIconHeight,
  },
  inputWrapperStyle: {
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    borderRadius: "none",
    padding: `${variables.paddingSmaller} ${variables.paddingSmall}`,
    gap: variables.gapXS,
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.fontSizeXxlarge,
    color: variables.grey3,
  },
};

function AssignSubProductCategory({
  options,
  placeholder,
  isRadioButtonsVisible,
  showRightArrows,
  onItemSelect = () => {}, //NOSONAR
  handleProductCheck = () => {}, //NOSONAR
  lastProductSelected,
  selectedSubProductCategoryId,
  searchedKey,
}) {
  const [allOptions, setAllOptions] = useState(options);

  useEffect(() => {
    setAllOptions(options);
  }, [options]);

  const filteredOptions = (e) => {
    const filteredArray = options?.filter((item) =>
      item?.[searchedKey].toLowerCase().includes(e.target.value.toLowerCase())
    );
    setAllOptions(filteredArray);
  };

  return (
    <TwoRow
      topSection={
        <Input
          prefix={
            <SearchOutlined
              style={{
                fontSize: variables.fontSizeNormal,
                color: variables.textDefault,
              }}
            />
          }
          style={style.inputWrapperStyle}
          placeholder={placeholder}
          onChange={filteredOptions}
        />
      }
      bottomSectionStyle={style.bottomSectionStyle}
      bottomSection={allOptions?.map((option) => {
        return (
          <div
            style={{
              ...style.optionItemStyle,
              ...(!showRightArrows && { justifyContent: "unset" }),
            }}
            className={`${Style["products-items-style"]} ${
              lastProductSelected === option.id ? Style["selected"] : ""
            }`}
            key={option?.id}
            onClick={onItemSelect(option?.id)}
          >
            {isRadioButtonsVisible && (
              <Radio
                onChange={(e) => handleProductCheck(option?.id)}
                checked={option?.id === selectedSubProductCategoryId}
                type="solid"
              />
            )}
            <Text style={style.optionNameStyle}>{option?.name}</Text>

            {showRightArrows && (
              <RightOutlined style={style.rightArrowIconStyle} />
            )}
          </div>
        );
      })}
    />
  );
}

export default AssignSubProductCategory;
